<template>
    <transition name="vue-table-loader">
        <div class="vue-table-loader master-loader" v-if="isLoaded">
            <span class="fa fa-cog fa-spin fa-3x"></span>
            <div class="dashboard-bg"></div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'master-loader',
    props: ['isLoaded'],
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to  {
    opacity: 0;
}
.vue-table-loader {
    position: absolute;
    z-index: 1000;
    left: -30px;
    right: -30px;
    top: 0;
    bottom: -30px;
    text-align: center;
    color: #25628F;
    padding-top: 60px;
    background-color: #F9FBFF;
}
.dashboard-bg{
    position: absolute;
    opacity: 0.2;
    background:transparent url('/images/bg-dashboard.png') center bottom no-repeat;
    background-size: 100% auto;
    z-index: -1;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 100vh;
}
</style>
